import { Text } from '@intigral/shared/components/Text';
import { COMPONENT_TYPES } from '@libs/constants';
import FullVODCarousel from '../../../../components/elements/FullVODCarousel';
import { __ } from '../../../../translations';
import { Separator, Spinner } from '@intigral/shared';
import useLanguage from '../../../../hooks/useLanguage';
import { useMoreLikeThis } from '../../hooks/useMoreLikeThis';
import { getVodItemGuid } from '../../utils/detailOverlayUtils';
import { ProgramAvailability } from '../../types/iSeasons';
import { getUserInfo } from '../../../../utils/user';
import { isGuestUser } from '../../../../config/guestMode';

type MoreLikeThisProps = {
    item: ProgramAvailability;
};

export const MoreLikeThis = ({ item }: MoreLikeThisProps) => {
    const language = useLanguage();
    const itemGuid = getVodItemGuid(item);
    const { isPending, isError, data } = useMoreLikeThis(itemGuid);

    if (isGuestUser(getUserInfo())) {
        return null;
    }

    if (isPending) {
        return (
            <>
                <Separator theme="bg" />
                <Spinner block />
            </>
        );
    }

    if (isError) {
        return null;
    }

    return (
        <>
            {data?.moreLikeThis?.length ? (
                <>
                    <Text
                        as="h2"
                        variant="h2"
                        alignment="start"
                        margin={{ default: '2x', md: '3x' }}
                        size={{ default: '18', md: '28' }}
                    >
                        {language === 'en'
                            ? __('search_recemmendation_moreLikeThis')
                            : __('search_recemmendation_moreLikeThis')}
                    </Text>
                    <FullVODCarousel
                        content={data.moreLikeThis ?? []}
                        componentType={COMPONENT_TYPES.FULLVOD_CATALOG_LIST}
                        componentName={COMPONENT_TYPES.FULLVOD_CATALOG_LIST}
                        itemsCount={4}
                    />
                </>
            ) : null}

            <Separator theme="bg" />
            {data?.otherRelated?.length ? (
                <>
                    <Text
                        as="h2"
                        variant="h2"
                        alignment="start"
                        margin={{ default: '2x', md: '3x' }}
                        size={{ default: '18', md: '28' }}
                    >
                        {language === 'en' ? __('other_also_watched') : __('other_also_watched')}
                    </Text>
                    <FullVODCarousel
                        content={data.otherRelated ?? []}
                        componentType={COMPONENT_TYPES.FULLVOD_CATALOG_LIST}
                        componentName={COMPONENT_TYPES.FULLVOD_CATALOG_LIST}
                        itemsCount={4}
                    />
                </>
            ) : null}
        </>
    );
};
